export const SETTING_TOKEN_INDEX = 'SETTING_TOKEN_INDEX';
export const SETTING_TOKEN_LOADING_INDEX = 'SETTING_TOKEN_LOADING_INDEX';
export const SETTING_TOKEN_LOADING_SHOW = 'SETTING_TOKEN_LOADING_SHOW';
export const SETTING_TOKEN_RESET = 'SETTING_TOKEN_RESET';
